import { apiBaseSlices } from "./baseAPI";

export const forwardersSlices = apiBaseSlices.injectEndpoints({
    endpoints: (builder) => ({
        getForwarderList: builder.mutation({
            query: ({ token, currentPage }) => ({
                url: `forwarders?page=${currentPage}`,
                method: "GET",
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            }),
        }),

        getForwarder: builder.mutation({
            query: ({ forwarderId, token }) => {
                return {
                    url: `forwarders/${forwarderId}`,
                    method: "GET",
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                }
            },
        }),

        createForwarder: builder.mutation({
            query: ({ payload, token }) => {
                return {
                    url: "forwarders",
                    method: "POST",
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: payload,
                };
            },
        }),

        updateForwarder: builder.mutation({
            query: ({ payload, forwarderId, token }) => ({
                url: `forwarders/${forwarderId}`,
                method: "PUT",
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: payload,
            }),
        }),

        deleteForwarder: builder.mutation({
            query: ({ forwarderId, token }) => ({
                url: `forwarders/${forwarderId}`,
                method: "DELETE",
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            }),
        }),

        regenerateToken: builder.mutation({
            query: ({ forwarderId, token }) => ({
                url: `forwarders/${forwarderId}/regenerate-token`,
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            }),
        }),
    }),
});

export const {
    useGetForwarderListMutation,
    useGetForwarderMutation,
    useCreateForwarderMutation,
    useUpdateForwarderMutation,
    useDeleteForwarderMutation,
    useRegenerateTokenMutation,
} = forwardersSlices;
